module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGf0fd5ae3ce221f75417ec4720937ca5d.3eee5858.jpg";